"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1511],{

/***/ 1511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Badge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./styles/jss/bbhost.js
var bbhost = __webpack_require__(21086);
;// CONCATENATED MODULE: ./styles/jss/bbhost/components/badgeStyle.js

var badgeStyle = {
    badge: {
        marginRight: "3px",
        borderRadius: "12px",
        padding: "5px 12px",
        textTransform: "uppercase",
        fontSize: "10px",
        fontWeight: "500",
        lineHeight: "1",
        color: "#fff",
        textAlign: "center",
        whiteSpace: "nowrap",
        verticalAlign: "baseline",
        display: "inline-block"
    },
    primary: {
        backgroundColor: bbhost/* primaryColor */.lr
    },
    warning: {
        backgroundColor: bbhost/* warningColor */.MA
    },
    danger: {
        backgroundColor: bbhost/* dangerColor */.E7
    },
    success: {
        backgroundColor: bbhost/* successColor */.nq
    },
    info: {
        backgroundColor: bbhost/* infoColor */.bE
    },
    rose: {
        backgroundColor: bbhost/* roseColor */.An
    },
    gray: {
        backgroundColor: "#6c757d"
    }
};
/* harmony default export */ var components_badgeStyle = (badgeStyle);

;// CONCATENATED MODULE: ./components/Badge/Badge.js


// nodejs library to set properties for components

// @material-ui/core components


var useStyles = (0,makeStyles/* default */.Z)(components_badgeStyle);
function Badge(props) {
    var classes = useStyles();
    var color = props.color, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classes.badge + " " + classes[color],
        children: children
    });
}
Badge.defaultProps = {
    color: "gray"
};
Badge.propTypes = {
    color: prop_types_default().oneOf([
        "primary",
        "warning",
        "danger",
        "success",
        "info",
        "rose",
        "gray"
    ]),
    children: (prop_types_default()).node
};


/***/ })

}]);